import React, { SVGProps } from "react";

export default function SupWallet(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M15.6 13.2V10H16.4V13.2H15.6Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4C2 2.89543 2.89543 2 4 2H14.8V5.2H18V14.4C18 16.3882 16.3882 18 14.4 18H5.6C3.61177 18 2 16.3882 2 14.4V4ZM4 2.8H14V5.2H11.2V6H17.2V14.4C17.2 15.9464 15.9464 17.2 14.4 17.2H5.6C4.0536 17.2 2.8 15.9464 2.8 14.4V5.60015C3.13426 5.85122 3.54976 6 4 6H11.2V5.2H4C3.33726 5.2 2.8 4.66274 2.8 4C2.8 3.33726 3.33726 2.8 4 2.8Z"
        fill="currentColor"
      />
    </svg>
  );
}
